module.exports = __webpack_public_path__ + "static/media/logoITESM.8b802e40.svg";